import { render, staticRenderFns } from "./EditAddOnItem.vue?vue&type=template&id=5d9fa503&scoped=true&"
import script from "./EditAddOnItem.vue?vue&type=script&lang=js&"
export * from "./EditAddOnItem.vue?vue&type=script&lang=js&"
import style0 from "./EditAddOnItem.vue?vue&type=style&index=0&id=5d9fa503&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fa503",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSelect,VSpacer})
